<template>
  <div :class="styleForPDF ? 'table-pdf-format' : 'height100'" id="table-pdf-format">
    <div class="main-wrapper height100">
      <div class="users-block">
        <div v-for="user in shift.users" :key="user.id" class="user-line" @click="goToTeamPlan(user)">
          <div>
            {{ user.name }}
          </div>
        </div>
      </div>
      <div class="shift-wrapper height100">
        <div class="shift-block height100">
          <div
            v-for="column in shift.columns"
            :key="column.date"
            :class="`column-block ${moment(column.date).format('ddd') === 'Sun' ? 'is-sunday' : ''}`"
          >
            <div :class="`date-block ${moment(column.date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') ? 'active-text' : ''}`">
              <div class="date-number">{{ moment(column.date).format('D') }}</div>
              <div class="date-name">{{ moment(column.date).format('ddd') | i18n }}</div>
            </div>

            <div
              v-for="u in shift.users"
              :key="`${column.date}${column.cellsByUserID[u.id]}${u.id}`"
              class="shift-cell"
              @click="selectSell(column.cellsByUserID[u.id], column.date, u.id)"
            >
              <div class="shift-cell-box" :style="`background: ${getLableColor(column.cellsByUserID[u.id])}`">
                <div :class="`cell-status `">
                  {{ `${column.cellsByUserID[u.id]}` | i18n }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  title: 'ShiftbaseTable',
  props: {
    userLineSize: {
      type: Number,
      default: 0,
    },
    styleForPDF: {
      type: Boolean,
      default: false,
    },
    shiftColors: {
      type: Object,
      default: () => {},
    },
    shift: {
      type: Object,
      default: () => {},
    },
    goToTeamPlan: {
      type: Function,
      default: () => {},
    },
    selectSell: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      moment,
    };
  },
  methods: {
    getLableColor(name) {
      return this.shiftColors && this.shiftColors[name] ? this.shiftColors[name] : 'white';
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-warning {
  color: white !important;
}

.height100 {
  height: 100%;
}
.total-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.alert-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  text-align: center;
}

.shift-block {
  display: flex;
  flex-direction: row;
  overflow: scroll;
  min-height: calc(100vh - 190px);
}

$user-width: 140px;

.shift-wrapper {
  padding-left: $user-width;
}

.column-block {
  min-width: 95px;
  border-right: 1px solid rgb(244, 242, 246);
  min-height: 100%;
}

.main-wrapper {
  position: relative;
}

.users-block {
  min-width: $user-width;
  width: $user-width;
  position: absolute;
  padding-top: 80px;
  box-shadow: 6px 0px 7px -8px rgba(34, 60, 80, 0.6);
  height: 100%;
  padding-right: 10px;
}

.user-line {
  height: 60px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f4f2f6;
  overflow: hidden;
  cursor: pointer;
  padding-left: 10px;
}

.user-line:hover {
  border-radius: 15px;
  background: #f4f2f6;
}

.date-block {
  height: 80px;
  padding-left: 10px;
  padding-top: 10px;
  border-bottom: 1px solid #f4f2f6;
}

.date-number {
  font-size: 22px;
  color: rgb(66, 68, 72);
}

.date-name {
  font-size: 14px;
  color: rgb(168, 173, 187);
}

.active-text {
  div {
    color: #2260ff !important;
  }
}

.shift-cell-box {
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
}

.shift-cell {
  height: 60px;
  border-bottom: 1px solid #f4f2f6;
  cursor: pointer;
}

.cell-status {
  border-radius: 15px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  padding: 0 4px;
  cursor: pointer;
  color: white;
}

.cell-status-color {
  width: 7px;
  height: 7px;
  border-radius: 7px;
}

.is-sunday {
  border-right: 3px solid #6b6b6b;
}

.table-pdf-format {
  height: 794px !important;
  font-size: 10px !important;
  width: 1125px !important;
  display: flex;
  padding: 20px 0px;
  flex-direction: column;

  .date-block {
    padding: 0px;
    padding-left: 5px;
  }
  .column-block {
    min-width: 31.5px;
  }
  .cell-status {
    padding: 0px;
  }
  .date-name {
    font-size: 7px;
  }
  .date-number {
    font-size: 10px;
  }
  .users-block {
    padding-top: 30px;
  }
  .date-block {
    height: 30px;
  }
  .is-sunday {
    border-right: 1px solid #6b6b6b;
  }
  .user-line {
    height: 30px;
  }
  .shift-cell {
    height: 30px;
  }
  .cell-status {
    font-size: 6px;
  }
}
</style>
